// sublayout dashbordu - menu w sidebarze

import React, { FC, useCallback, useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Grid } from '@mui/material';
import classnames from 'classnames';
import each from 'lodash/each';
import find from 'lodash/find';

import { useSelector } from 'store';
import { useAppNavigate } from 'hooks';
import { Container, Breadcrumbs } from 'components/controls';
import { DashboardMenu } from 'components/containers';
import { ICompanyUserSettings } from 'api/endpoints/useGetUserProfile';

import styles from 'theme/components/layouts/DashboardSubLayout/SubLayoutDashboard.module.scss';

// typ danych wejściowych
interface IProps {
  urlPrefix: string;
}

interface IRoute {
  label: string;
  path: string;
  key: string | null;
}

export const userRolesAccessRoutes = () => ({
  ROLE_USER_MAIN: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Do akceptacji', path: '/dashboard/orders-to-approve', key: 'orders-to-approve' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [
      { label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' },
      { label: 'Zwroty i reklamacje', path: '/dashboard/returns-complaints', key: 'returns-complaints' },
    ],
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Struktura firmy', path: '/dashboard/company', key: 'company' },
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_USER: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Do akceptacji', path: '/dashboard/orders-to-approve', key: 'orders-to-approve' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [
      { label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' },
      { label: 'Zwroty i reklamacje', path: '/dashboard/returns-complaints', key: 'returns-complaints' }],
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Struktura firmy', path: '/dashboard/company', key: 'company' },
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_ADMIN: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Do akceptacji', path: '/dashboard/orders-to-approve', key: 'orders-to-approve' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [
      { label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' },
      { label: 'Zwroty i reklamacje', path: '/dashboard/returns-complaints', key: 'returns-complaints' }]
    ,
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Struktura firmy', path: '/dashboard/company', key: 'company' },
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_TRADER: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Do akceptacji', path: '/dashboard/orders-to-approve', key: 'orders-to-approve' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [{ label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' }],
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [
      { label: 'Lista klientów', path: '/dashboard/clients', key: 'clients' },
      { label: 'Adresy dostaw', path: '/dashboard/receivers', key: 'receivers' }
    ],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Struktura firmy', path: '/dashboard/company', key: 'company' },
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_TRADER_MANAGER: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Do akceptacji', path: '/dashboard/orders-to-approve', key: 'orders-to-approve' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [{ label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' }],
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [
      { label: 'Lista klientów', path: '/dashboard/clients', key: 'clients' },
      { label: 'Adresy dostaw', path: '/dashboard/receivers', key: 'receivers' }
    ],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Struktura firmy', path: '/dashboard/company', key: 'company' },
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_OPEN_PROFILE: {
    orders: [],
    carts: [],
    payments: [],
    offers: [],
    documents: [],
    myData: [],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  }
});

/**
 * Filtruje sekcje menu panelu klienta na podstawie ustawien CompanyUser.
 *
 * Reguly:
 *  - "Struktura firmy" widoczna TYLKO dla ROLE_USER_MAIN (admin firmy klienta).
 *    Vendor TRADER / TRADER_MANAGER / ADMIN sklepu rowniez jej nie widza - to zakladka panelu KLIENTA.
 *  - Sekcje "Platnosci", "Oferty", "Dokumenty" - na podstawie permissions z CompanyUser
 *    (tylko dla ROLE_USER i ROLE_USER_MAIN; vendor TRADER/TRADER_MANAGER/ADMIN widza wszystko inne)
 *  - Sub-route "Zwroty i reklamacje" w sekcji documents - na podstawie permissions.returns
 *  - Dla userow bez CompanyUser (has_company_config=false) zachowujemy pelny dostep do
 *    modulow biznesowych (default allow)
 */
export const filterAccessRoutesByPermissions = (
  routes: ReturnType<typeof userRolesAccessRoutes>[keyof ReturnType<typeof userRolesAccessRoutes>],
  role: string | undefined,
  companyUserSettings: ICompanyUserSettings | undefined
) => {
  // is_main_user pochodzi z backendu (CompanyUserPermissionsProvider) i jest true
  // dla ROLE_USER_MAIN, ROLE_TRADER, ROLE_TRADER_MANAGER, ROLE_ADMIN, ROLE_CLIENT_API.
  const isMainUser = companyUserSettings?.is_main_user ?? false;
  // can_manage_department = true dla company_role = 'manager' | 'admin' (zarzadcy
  // dzialu). Manager widzi "Strukture firmy" ale tylko swoj dzial.
  const canManageDepartment = companyUserSettings?.can_manage_department ?? false;

  // "Struktura firmy" - widoczna dla ROLE_USER_MAIN/admina firmy oraz dla managerow dzialu
  const myCompany = routes.myCompany.filter(
    (item) => item.key !== 'company' || isMainUser || canManageDepartment
  );

  // Vendor TRADER / TRADER_MANAGER / ADMIN sklepu - zachowujemy pelny dostep do modulow biznesowych
  // (poza struktura firmy, ktora juz odfiltrowana powyzej)
  if (role === 'ROLE_TRADER' || role === 'ROLE_TRADER_MANAGER' || role === 'ROLE_ADMIN') {
    return { ...routes, myCompany };
  }

  // Dla ROLE_USER/ROLE_USER_MAIN bez wpisu CompanyUser - default allow
  if (!companyUserSettings) {
    return { ...routes, myCompany };
  }

  const permissions = companyUserSettings.permissions;

  // Sekcja "Dokumenty" - osobno filtrujemy main entry i sub "Zwroty"
  let documents = routes.documents;
  if (!permissions.documents) {
    documents = documents.filter((item) => item.key !== 'documents');
  }
  if (!permissions.returns) {
    documents = documents.filter((item) => item.key !== 'returns-complaints');
  }

  // Platnosci - cala sekcja ukryta gdy brak uprawnienia
  const payments = permissions.payments ? routes.payments : [];

  // Oferty - cala sekcja ukryta gdy brak uprawnienia
  const offers = permissions.offers ? routes.offers : [];

  return {
    ...routes,
    payments,
    offers,
    documents,
    myCompany
  };
};

const SubLayoutDashboard: FC<IProps> = ({ urlPrefix }) => {
  const { profile } = useSelector((state) => state.auth);
  const navigate = useAppNavigate();

  // ścieżka z url
  const { pathname } = useLocation();

  // Ustawienia CompanyUser z backendu (CompanyUserPermissionsProvider w Wise/Company).
  // Sterują widocznością modułów: documents, payments, offers, returns + struktura firmy.
  const companyUserSettings = profile?.additional_information?.company_user_settings;

  // Przefiltrowane route'y dla aktualnej roli i uprawnień - jedno źródło prawdy dla menu i guardów
  const filteredAccessRoutes = profile?.role
    ? filterAccessRoutesByPermissions(
        userRolesAccessRoutes()[`${profile.role}`],
        profile.role,
        companyUserSettings
      )
    : null;

  // czy użytkownik ma dostęp do podstrony
  const allowRoute = useCallback(() => {
    if (!filteredAccessRoutes) {
      return true;
    }
    let arr: IRoute[] = [{ label: 'Dashboard', path: '/dashboard', key: null }];

    each(filteredAccessRoutes, (route) => (arr = [...arr, ...route]));

    return !!find(arr, (route) => route.key && pathname.includes(route.key));
  }, [pathname, profile?.role, filteredAccessRoutes]);

  useEffect(() => {
    if (pathname === `${urlPrefix}/dashboard`) {
      return;
    }

    // Czekaj na załadowanie profilu - bez tego użytkownik wchodzący bezpośrednio
    // na podstronę z linku (np. wysłanego mailem) zostanie błędnie przekierowany
    // do /dashboard zanim Redux załaduje rolę.
    if (!profile?.role) {
      return;
    }

    if (!allowRoute()) {
      navigate('/dashboard');
    }
  }, [pathname, profile?.role]);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Layouts-DashboardSubLayout'
      )}>
      <Container>
        <Breadcrumbs />
        <Grid container columnSpacing="32px">
          <Grid item md={2} xs={12} className={styles.menuWrapper}>
            {profile?.role && filteredAccessRoutes ? (
              <DashboardMenu accessRoutes={filteredAccessRoutes} />
            ) : (
              <div className={styles.menuSkeleton}>
                {[...Array(6)].map((_, i) => (
                  <div key={i} className={styles.menuSkeletonItem}>
                    <div className={styles.menuSkeletonLine} style={{ width: `${60 + (i % 3) * 15}%` }} />
                  </div>
                ))}
              </div>
            )}
          </Grid>
          <Grid item md={10} xs={12}>
            <Outlet />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default SubLayoutDashboard;
